<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <form class="form-inline">
            <input v-model="ShowDate" @change="loadData()" type="date" class="form-control" />

            <select v-model="SelectedSet" @change="changeSelected()" class="form-control ml-sm-2">
              <option
                v-for="FavSet in FavSets"
                :value="FavSets.indexOf(FavSet)"
                :key="FavSets.indexOf(FavSet)"
              >{{FavSets.indexOf(FavSet)}}: {{FavSet.Description}}</option>
            </select>

            <router-link
              :to="{name:'favsetedit', params:{favsetid: SelectedSet}}"
              class="btn btn-link"
            >Edit FavSet</router-link>

            <router-link
              :to="{name:'favsetedit', params:{favsetid: -1}}"
              class="btn btn-link"
            >New FavSet</router-link>
          </form>
        </div>
      </div>
    </div>

    <br />

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Time</th>
          <th v-for="channel in ServerResponse.Channels" :key="channel.Number">
            <router-link
              :to="{name:'masterdetailselected', params:{chcode: channel.Number}}"
            >{{channel.Name}}</router-link>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in Rows" :key="row.ShowTime">
          <td :title="row.ShowTimeDate">{{row.ShowTimeStr}}</td>
          <td v-for="cell in row.Cells" :key="cell.Show.ChannelNumber" :rowspan="cell.Span">
            <span>{{cell.Show.Title}}</span>
            <br />
            <span
              v-if="!!cell.Show.Channel"
            >{{cell.Show.ChannelNumber}}: {{cell.Show.DateStartStr}} - {{cell.Show.DateEndStr}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import API from "../apis/firstmedia.js";
import moment from "moment";
import _ from "lodash";

export default {
  data() {
    return {
      SelectedSet: this.$store.state.settings.settings.SelectedSet,
      ShowDate: moment().format("YYYY-MM-DD"),
      ServerResponse: {},
      Rows: []
    };
  },
  computed: {
    FavSets() {
      return this.$store.state.settings.settings.FavSets;
    }
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      let channelNumbers = this.FavSets[this.SelectedSet].Channels.map(
        c => c.Number
      );
      let dateStart = moment(this.ShowDate).toISOString();
      let dateEnd = moment(dateStart)
        .add(1, "days")
        .toISOString();

      let spinnerToken = await this.$store.dispatch("spinner/needSpinner");
      this.ServerResponse = await API.getSchedule(
        channelNumbers,
        dateStart,
        dateEnd
      );
      this.$store.dispatch("spinner/dontNeedSpinner", spinnerToken);

      this.ServerResponse.Schedules.forEach(s => {
        s.DateStart = moment(s.DateStart).toISOString();
        s.DateStartDate = moment(s.DateStart).toDate();
        s.DateStartStr = moment(s.DateStart).format("HH:mm");
        s.DateEnd = moment(s.DateEnd).toISOString();
        s.DateEndDate = moment(s.DateEnd).toDate();
        s.DateEndStr = moment(s.DateEnd).format("HH:mm");
        s.Channel = this.ServerResponse.Channels.find(
          c => c.Number == s.ChannelNumber
        );
      });

      this.ServerResponse.Schedules.forEach(s => {
        s.DateStartView = s.DateStart < dateStart ? dateStart : s.DateStart;
        s.DateEndView = s.DateEnd > dateEnd ? dateEnd : s.DateEnd;
      });

      let allShowTimes = this.trimShowTimes(
        this.getAllShowTimes(this.ServerResponse.Schedules),
        dateStart,
        dateEnd
      );

      this.Rows = this.generateTable(
        this.ServerResponse.Schedules,
        this.ServerResponse.Channels,
        allShowTimes
      );
    },
    changeSelected() {
      let allSettings = this.$store.state.settings.settings;
      allSettings.SelectedSet = this.SelectedSet;
      this.$store.dispatch("settings/updateAll", allSettings);
      this.loadData();
    },
    getAllShowTimes(schedules) {
      let showtimes = schedules
        .map(s => s.DateStart)
        .concat(schedules.map(s => s.DateEnd));
      let uniqueTimes = Array.from(new Set(showtimes));
      let sortedTimes = _.sortBy(uniqueTimes, t => t);
      return sortedTimes;
    },
    trimShowTimes(allShowTimes, timeStart, timeEnd) {
      if (allShowTimes.find(t => t < timeStart)) {
        allShowTimes = allShowTimes.filter(t => t >= timeStart);
        if (!allShowTimes.includes(timeStart)) {
          allShowTimes.unshift(timeStart);
        }
      }

      if (allShowTimes.find(t => t > timeEnd)) {
        allShowTimes = allShowTimes.filter(t => t <= timeEnd);
        if (!allShowTimes.includes(timeEnd)) {
          allShowTimes.push(timeEnd);
        }
      }

      return allShowTimes;
    },
    generateCells(showTime, channels, schedules, allShowTimes) {
      let cells = [];
      for (const channel of channels) {
        let currentShow = schedules.find(
          s =>
            s.ChannelNumber == channel.Number &&
            s.DateStart <= showTime &&
            s.DateEnd > showTime
        );

        if (!currentShow) {
          // if no shows found, insert blank cell
          let cell = {
            Show: {},
            Span: 1
          };
          cells.push(cell);
          continue;
        }

        if (currentShow.DateStartView == showTime) {
          // if start time match
          let span =
            allShowTimes.indexOf(currentShow.DateEndView) -
            allShowTimes.indexOf(currentShow.DateStartView);
          let cell = {
            Show: currentShow,
            Span: span
          };
          cells.push(cell);
          continue;
        }

        // has show but start time doesn't match: do nothing
      }
      return cells;
    },
    generateTable(schedules, channels, allShowTimes) {
      let rows = allShowTimes.map(showTime => {
        let row = {
          ShowTime: showTime,
          ShowTimeStr: moment(showTime).format("HH:mm"),
          ShowTimeDate: moment(showTime).toDate(),
          Cells: this.generateCells(showTime, channels, schedules, allShowTimes)
        };
        return row;
      });
      return rows;
    }
  }
};
</script>